import React from 'react';
import postData from "../service/fetcher";

export default class Create extends React.Component {

    constructor(props) {
        super(props);
        this.input = this.input.bind(this);
        this.check = this.check.bind(this);
        this.post = this.post.bind(this);
    }

    componentDidMount() {
        this.setState({name: this.props.name})
    }

    post() {
        this.setState({post: true}, () => postData("/api/CreateFolder", {token: this.props.token}, {
                name: this.state.name,
                public: (this.state.public ? 1 : 0)
            })[0].then((data) => this.setState({
                id: data.id.toString()
            }, () => this.props.page("folder", data.id.toString()))).catch(() => console.log("failed to create folder"))
        );

    }

    state = {name: undefined, public: false, post: false};

    input(e) {
        this.setState({name: e.target.value})
    }

    check(e) {
        this.setState({public: e.target.checked})
    }

    render() {
        return (<div>
                {
                    this.state.post && <p>Nieuwe map aan het aanmaken!</p>
                }
                {!this.state.post &&
                    <div>
                        <h1>Nieuwe map</h1>
                        <p>naam: {this.state.name}</p>
                        <input type="text" onChange={(e) => this.input(e)}/>

                        <p>Zichtbaarheid: {this.state.public ? "publiek" : "niet publiek"}</p>
                        <input type="checkbox" onChange={(e) => this.check(e)}/>
                        <button onClick={this.post}>Nieuwe map maken</button>
                    </div>
                }
            </div>
        );
    }


}
